import * as actionTypes from '../actions/actionTypes'

const initialState = {
  data: {},
  error: null,
}

export const validate = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.VALIDATE_ACCOUNT_SUCCESS:
      const data  = action.payload;
      return { ...state, data };
    case actionTypes.VALIDATE_ACCOUNT_ERROR:
      return { ...state, data: [], error: action.payload };
    default:
      return state
  }
}
